export default "__VITE_ASSET__Uqetif2f__"